import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjaincabservice() {



  const cardData = {
"keyword": "Pune to Ujjain Cab Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Ujjain Cab Service for travelers seeking safe, affordable, and convenient long-distance transportation. Whether you are traveling for pilgrimage, family visits, tourism, spiritual tours, or business travel, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Ujjain. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and corporate clients. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures comfortable and timely travel between Pune and Ujjain.",

"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga",
    "description":
      "Mahakaleshwar Jyotirlinga is one of the twelve sacred Jyotirlingas dedicated to Lord Shiva and the most famous pilgrimage destination in Ujjain. Travelers using Pune to Ujjain cab service often visit this holy temple for spiritual blessings."
  },
  {
    "title": "Kal Bhairav Temple",
    "description":
      "Kal Bhairav Temple is a renowned religious site in Ujjain dedicated to Lord Kal Bhairav. Cab travelers from Pune frequently include this spiritually significant temple in their pilgrimage itinerary."
  },
  {
    "title": "Ram Ghat",
    "description":
      "Ram Ghat is a sacred bathing ghat on the banks of the Shipra River known for evening aarti and religious rituals. Pune to Ujjain taxi service offers convenient access for devotees and tourists."
  },
  {
    "title": "Harsiddhi Temple",
    "description":
      "Harsiddhi Temple is an ancient Shakti Peeth and one of the most revered temples in Ujjain. Travelers booking Pune to Ujjain cabs often visit this spiritual landmark."
  },
  {
    "title": "Sandipani Ashram",
    "description":
      "Sandipani Ashram is believed to be the place where Lord Krishna received education from Guru Sandipani. Taxi from Pune to Ujjain provides comfortable travel for cultural and spiritual exploration."
  },
  {
    "title": "Mangalnath Temple",
    "description":
      "Mangalnath Temple is considered the birthplace of planet Mars according to Hindu beliefs and is famous for astrology-related rituals. Pune to Ujjain cab booking is popular among pilgrims visiting this temple."
  },
  {
    "title": "ISKCON Temple Ujjain",
    "description":
      "ISKCON Temple in Ujjain is a peaceful spiritual destination known for devotional activities and beautiful temple architecture. Travelers from Pune often visit this serene attraction."
  },
  {
    "title": "Vedh Shala (Jantar Mantar)",
    "description":
      "Vedh Shala is an ancient observatory in Ujjain showcasing astronomical instruments and scientific heritage. Pune to Ujjain cab service makes it easy for visitors interested in history and astronomy."
  },
  {
    "title": "Bade Ganeshji Ka Mandir",
    "description":
      "Bade Ganeshji Ka Mandir is a famous temple dedicated to Lord Ganesha known for its large idol and spiritual atmosphere. Cab travelers from Pune often include this temple in their tour."
  },
  {
    "title": "Shipra River",
    "description":
      "Shipra River is a sacred river in Ujjain associated with religious rituals, Kumbh Mela, and spiritual importance. Pune to Ujjain taxi service ensures smooth travel for pilgrims visiting the ghats and temples nearby."
  }
],



services: [
  {
    name: "Pune to Ujjain Cab",
    description: "Pune to Ujjain cab service provides reliable long-distance transportation between Pune and Ujjain with comfortable vehicles and experienced drivers. Vehicles are suitable for highway travel ensuring smooth and safe journeys for families, pilgrims, tourists, and business travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ujjain. Vehicles include sedans, SUVs, Innova Crysta, Urbania, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Ujjain Cab Service",
    description: "Pune to Ujjain cab service provides dependable transportation solutions for passengers traveling between Pune and Ujjain with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for highway travel ensuring safe and smooth journeys for individuals, families, and pilgrimage groups. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ujjain. Ideal for Mahakal Darshan, tourism, and family trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Ujjain Taxi Service",
    description: "Pune to Ujjain taxi service offers dependable transportation for passengers traveling between Pune and Ujjain with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for pilgrimage tours, tourism, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Ujjain. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Pune to Ujjain Cab Booking",
    description: "Pune to Ujjain cab booking service allows passengers to reserve comfortable intercity transportation between Pune and Ujjain. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, Urbania, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ujjain. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Best Pune to Ujjain Cab",
    description: "Best Pune to Ujjain cab service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth intercity travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for pilgrimage travel, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ujjain. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "One Way Pune to Ujjain Cab",
    description: "One way Pune to Ujjain cab service provides economical transportation for passengers traveling from Pune to Ujjain without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for pilgrimage trips, tourism, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Ujjain including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Round Trip Pune to Ujjain Taxi",
    description: "Round trip Pune to Ujjain taxi service offers convenient return transportation for passengers planning travel between Pune and Ujjain. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ujjain. Ideal for religious tours, tourism, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Cheap Pune to Ujjain Cab",
    description: "Cheap Pune to Ujjain cab service provides affordable transportation between Pune and Ujjain with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for pilgrimage tours, tourism, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Ujjain. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "24x7 Pune to Ujjain Cab Service",
    description: "24x7 Pune to Ujjain cab service offers round-the-clock transportation between Pune and Ujjain with comfortable vehicles and professional chauffeurs. Vehicles ensure smooth highway travel suitable for urgent travel, temple visits, and long-distance family journeys. Professional drivers ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Ujjain. Flexible booking options allow convenient anytime cab reservations."
  },
  {
    name: "Outstation Cab Pune to Ujjain",
    description: "Outstation cab Pune to Ujjain service provides dependable long-distance transportation for passengers traveling from Pune to Ujjain and nearby Madhya Pradesh destinations. Comfortable vehicles ensure smooth highway journeys suitable for pilgrimage tours, tourism, and family travel. Professional chauffeurs ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Ujjain. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Pune to Indore Taxi",
    description: "Pune to Indore taxi service provides reliable transportation between Pune and Indore with comfortable vehicles and experienced drivers. Vehicles offer smooth highway travel suitable for business trips, tourism, and family travel requirements. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Indore. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Pune to Bhopal Taxi",
    description: "Pune to Bhopal taxi service offers dependable transportation between Pune and Bhopal with spacious vehicles and professional chauffeurs. Vehicles ensure smooth long-distance highway travel suitable for tourism, business journeys, and family travel. Professional drivers ensure timely pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Bhopal. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Pune to Gwalior Cab Booking",
    description: "Pune to Gwalior cab booking service allows passengers to reserve comfortable long-distance transportation between Pune and Gwalior. Vehicles include sedans, SUVs, Innova Crysta, and luxury taxis suitable for different passenger requirements. Professional drivers ensure safe driving and smooth highway travel throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Gwalior. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Pune to Jabalpur Taxi",
    description: "Pune to Jabalpur taxi service provides reliable transportation between Pune and Jabalpur with comfortable vehicles and professional drivers. Vehicles offer smooth highway performance suitable for family trips, tourism, and business travel. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Jabalpur. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Pune to Ujjain Urbania",
    description: "Pune to Ujjain Urbania service provides premium group transportation for families and travel groups visiting Ujjain from Pune. Urbania vehicles offer spacious seating, luxury interiors, and smooth highway travel suitable for long-distance journeys. Professional chauffeurs ensure safe driving and comfortable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Ujjain. Flexible booking options allow convenient Urbania reservations."
  },
  {
    name: "Luxury Cab Pune Madhya Pradesh",
    description: "Luxury cab Pune Madhya Pradesh service offers premium transportation from Pune to major cities across Madhya Pradesh with high-end vehicles and professional chauffeurs. Vehicles provide spacious seating, luxury interiors, and smooth highway performance suitable for business executives, family tours, and premium travel experiences. Professional drivers ensure punctual pickup and safe transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Madhya Pradesh destinations. Flexible booking options allow convenient luxury cab reservations."
  }
],

tableData: [
  ["Pune to Ujjain Cab", "Pune to Ujjain Cab Service"],
  ["Pune to Ujjain Taxi Service", "Pune to Ujjain Cab Booking"],
  ["Best Pune to Ujjain Cab", "One Way Pune to Ujjain Cab"],
  ["Round Trip Pune to Ujjain Taxi", "Cheap Pune to Ujjain Cab"],
  ["24x7 Pune to Ujjain Cab Service", "Outstation Cab Pune to Ujjain"],
  ["Pune to Indore Taxi", "Pune to Bhopal Taxi"],
  ["Pune to Gwalior Cab Booking", "Pune to Jabalpur Taxi"],
  ["Pune to Ujjain Urbania", "Luxury Cab Pune Madhya Pradesh"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Ujjain Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Ujjain cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe long-distance travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Ujjain Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Ujjain cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Ujjain Cab Service Availability",
        WhyChoosedescription: "Our Pune to Ujjain cab service operates 24 hours a day for religious travel, family trips, temple visits, business tours, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Sanitized AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences for passengers."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Ujjain taxi service, round-trip bookings, Mahakal Darshan tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Options",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for individuals, families, pilgrims, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Interstate Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Ujjain highway routes and ensure safe driving, smooth travel, and timely arrival for every religious and interstate journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Ujjain cab service?", answer: "Pune to Ujjain cab service provides comfortable taxi transportation between Pune and Ujjain for Mahakal Darshan, religious travel, and family trips." },
    { question: "Is Pune to Ujjain cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Ujjain cab service." },
    { question: "Which vehicles are available for Pune to Ujjain travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Ujjain?", answer: "Yes, customers can book one-way as well as round-trip Pune to Ujjain taxi services." },
    { question: "Do you provide Mahakal Darshan cab packages?", answer: "Yes, Shivai Travels provides Mahakal Darshan and Ujjain temple tour cab services." },
    { question: "Are all Pune to Ujjain taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune to Ujjain cab service online?", answer: "Yes, customers can easily book Pune to Ujjain cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Ujjain cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Ujjain cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive travel seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Mahesh Sharma",
      feedback:
        "Booked Pune to Ujjain cab service with Shivai Travels for Mahakal Darshan. Comfortable vehicle and very smooth journey.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Kavita Joshi",
      feedback:
        "Excellent Pune to Ujjain taxi service. Affordable pricing, punctual pickup, and professional driver support.",
      rating: 5
    }
  ];






























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ujjain Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-ujjain-cab.jpg",
  "description": "Book Pune to Ujjain cab service for safe and comfortable pilgrimage and outstation travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-ujjain-cab"
  }
};










  return (
    <div>

<Helmet>
  <title>Pune to Ujjain Cab Service | Affordable Pilgrimage Taxi | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Ujjain cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for safe pilgrimage and outstation journeys."
  />

  <meta
    name="keywords"
    content="Pune to Ujjain Cab, Pune to Ujjain Cab Service, Pune to Ujjain Taxi Service, Pune to Ujjain Cab Booking, Best Pune to Ujjain Cab, One Way Pune to Ujjain Cab, Round Trip Pune to Ujjain Taxi, Cheap Pune to Ujjain Cab, 24x7 Pune to Ujjain Cab Service, Outstation Cab Pune to Ujjain, Pune to Indore taxi, Pune to Bhopal taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/31.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoujjaincabservice;